export const MY_TEAM_FILTERS = {
  ISSUER: 'issuer',
  MANAGER: 'manager',
  APPRAISER: 'appraiser',
  COAPPRAISER: 'coappraiser',
};

export const RELATION_SORT_PRECEDENCE = {
  Appraiser: 1,
  'Leave Issuer': 2,
  'Co-Appraiser': 3,
  'Team Manager': 4,
  'Project Manager': 5,
  'Team Lead': 6,
  'Team Member': 7,
};

export const MY_TEAM_SORT_BY = {
  PLANNED_LEAVES: 'plannedLeaves',
};

export const ORDER_BY = {
  ASC: 'asc',
  DESC: 'desc',
};

export const TEAM_MANAGER = 'Team Manager';

export const APPRAISER = 'Appraiser';
export const CO_APPRAISER = 'Co-Appraiser';

export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const WEEK_DAY_INITIALS = ['M', 'T', 'W', 'T', 'F'];
export const ALLOCATION_SEGMENT_COLORS = ['#4FA6DF', '#A64DDB', '#EB9630', '#F3B602', '#3EA76A', '#E35B8F'];

export const RELATION_LABELS: Record<string, string> = {
  teamManager: 'Team Manager for',
  leaveIssuer: 'Leave Issuer for',
  accountManager: 'Account Manager for',
  relationshipManager: 'Relationship Manager for',
  'accountManager/relationshipManager': 'Account Manager/Relationship Manager for',
  teamMember: 'Team Member for',
  appraiser: 'Appraiser for',
  coAppraiser: 'Co-Appraiser for',
};

export const TEAM_GROUP_ORDER = [
  'teamManager',
  'leaveIssuer',
  'accountManager',
  'relationshipManager',
  'appraiser',
  'coAppraiser',
  'teamMember',
];

export const MY_TEAM_LABELS = {
  PAGE_TITLE: 'My Team',
  TODAY: 'Today',
  COLLAPSE_ALL: 'Collapse all',
  EXPAND_ALL: 'Expand all',
  WEEKLY_ROSTER: 'Weekly Roster',
  ALLOCATION_PER_WEEK: 'Allocation(s) per week',
  PLANNED_LEAVE: 'Planned Leave',
  ALLOCATIONS: 'Allocations',
  HOUR_SUFFIX: 'h',
  PLACEHOLDER: '-',
  CLOCK_IN_TIME: 'Clock in Time:',
  VIEW_FULL_CLOCK_IN_LOGS: 'View Full Clock-In Logs',
  SHIFT: 'Shift: ',
  ROSTER: 'Roster: ',
  ROSTER_UNTIL: 'Roster Until: ',
  ROSTER_TITLE_SUFFIX: 'Roster',
  CLOCK_IN_TIME_OF: 'Clock-in time of',
};

export const TEAM_COUNT_LABEL = {
  teamManager: 'Team Manager for',
  leaveIssuer: 'Leave Issuer for',
  // accountManager: 'Account Manager for',
  // relationshipManager: 'Relationship Manager for',
  // teamMember: 'Team Member for',
  appraiser: 'Appraiser for',
  coAppraiser: 'Co-Appraiser for',
};

export const TEAM_COUNT_LABEL_SHORT = {
  teamManager: 'TM',
  leaveIssuer: 'LI',
  // accountManager: 'AM',
  // relationshipManager: 'RM',
  // teamMember: 'Team Member',
  appraiser: 'Appraiser',
  coAppraiser: 'Co-Appraiser',
};
